import axios from 'axios';

export async function fetchDashboardConfig() {
  const token = localStorage.getItem('token');
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const res = await axios.get('/api/dashboard-config', { headers });
  return res.data?.config || { version: 1, cards: [] };
}

export async function saveDashboardConfig(config) {
  const token = localStorage.getItem('token');
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  await axios.put('/api/dashboard-config', { config }, { headers });
}
